import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl, defineMessages } from 'gatsby-plugin-react-intl';

import { intlShape } from '@prospectus/common/types/intlShape';
import ProspectusLink from '@prospectus/common/ui-strict/ProspectusLink';

const messages = defineMessages({
  'prospectus.course.business.request': {
    id: 'prospectus.course.business.request',
    description: 'Link to request more information about business purchase of this course',
    defaultMessage: 'Request information',
  },
});

function BaseRequestBtn({ intl, className, onClick }) {
  return (
    <ProspectusLink
      href="https://business.edx.org/?lead_source=edX+Course+Page&utm_campaign=B2B+Container&utm_source=Referral"
      className={className}
      analytics={{
        eventName: 'edx.bi.user.b2b.bulk.info.click',
      }}
      onClick={onClick}
    >
      {intl.formatMessage(messages['prospectus.course.business.request'])}
    </ProspectusLink>
  );
}

BaseRequestBtn.propTypes = {
  intl: intlShape.isRequired,
  className: PropTypes.string.isRequired,
  onClick: PropTypes.func,
};

BaseRequestBtn.defaultProps = {
  onClick: () => {},
};

export default injectIntl(BaseRequestBtn);
